import { PlusCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client/react';
import { Form as AntForm, App, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import type React from 'react';
import type { FormInput } from '../../../../graphql/generated/graphql.ts';
import { CREATE_FORM_MUTATION } from './CreateFormModal.gql';

export const CreateFormModal: React.FC<{
  labId: string;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}> = ({ labId, open, onClose, onSuccess }) => {
  const [createFormMutation, { loading }] = useMutation(CREATE_FORM_MUTATION);
  const [form] = useForm<FormInput>();
  const { message } = App.useApp();

  const create = async (values: FormInput) => {
    try {
      await createFormMutation({
        variables: {
          input: {
            ...values,
            labId: labId,
            fields: [],
          },
        },
      });

      message.success('Formular wurde erstellt');
      onSuccess();
      closeAndReset();
    } catch (_e) {
      message.error('Formular konnte nicht erstellt werden');
    }
  };

  const closeAndReset = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      width={600}
      title="Neues Formular erstellen"
      okText="Erstellen"
      okButtonProps={{ icon: <PlusCircleOutlined /> }}
      open={open}
      onCancel={closeAndReset}
      onOk={form.submit}
      confirmLoading={loading}
      destroyOnHidden
    >
      <AntForm<FormInput>
        form={form}
        layout="vertical"
        name="create-form"
        preserve
        initialValues={{
          labId: labId,
          name: '',
          header: '',
          description: '',
          pickup: false,
          printRequired: false,
          printBeforeSend: false,
          printCopies: 1,
          direct: false,
          restore: true,
          doctorIds: [],
          requiredByFrontDesk: false,
        }}
        onFinish={() => create(form.getFieldsValue(true))}
      >
        <AntForm.Item name="name" label="Bezeichnung" rules={[{ required: true, whitespace: true }]}>
          <Input />
        </AntForm.Item>
      </AntForm>
    </Modal>
  );
};
